import { ChevronDown } from "@reverb-ui/icons-react";
import { Box, SelectProps } from "@reverb-ui/react";
import React from "react";
import WindowedSelect from "react-windowed-select";

export interface CustomVirtualizedSelectProps extends SelectProps {
  hasError?: boolean;
}

const errorColor = "#C21F2D";

const getCustomStyles = (hasError?: boolean) => {
  return {
    container: (provided: any) => ({
      ...provided,
      flex: 1,
      width: "100%",
    }),
    menu: (provided: any) => ({
      ...provided,
      zIndex: 1000,
    }),
    menuPortal: (provided: any) => ({
      ...provided,
      zIndex: 1000,
    }),
    control: (provided: any, state: any) => {
      const modifiedStyles = {
        ...provided,
        width: "100%",
      };

      if (hasError) {
        if (state.isFocused) {
          modifiedStyles.boxShadow = `0 0 0 1px ${errorColor}`;
        }

        modifiedStyles["&:hover"] = {
          borderColor: errorColor,
        };
        modifiedStyles.borderColor = errorColor;
      }

      return modifiedStyles;
    },
  };
};

const DropdownIndicator = () => (
  <Box pr={3}>
    <ChevronDown size={15} color="gray.700" />
  </Box>
);

const CustomVirtualizedSelect = React.forwardRef<
  any,
  CustomVirtualizedSelectProps
>(({ hasError, ...props }, ref) => {
  return (
    <WindowedSelect
      ref={ref}
      styles={getCustomStyles(hasError)}
      components={{
        IndicatorSeparator: () => null,
        DropdownIndicator,
      }}
      windowThreshold={100}
      {...props}
    />
  );
});

export default CustomVirtualizedSelect;
